import type { BrandWarning } from '@innovationdepartment/proxima-sdk-axios';
import { Button, Table, type TableConfig, Text } from '@innovationdepartment/proxima-ui';
import BrandOverviewHeader from 'components/BrandOverview/Layout/BrandOverviewHeader';
import type { Dictionary } from 'lodash';
import type { Integration } from 'types/integrations';
import type { Brand } from 'types/stores/brand-store';
import ButtonGroup from 'ui/ButtonGroup';
import LoadingSpinner from 'ui/LoadingSpinner';
import SectionLayout from 'ui/SectionLayout';

type BrandWarningsModalViewProps = {
  brand: Brand;
  adAccountId: string | undefined;
  integrationsWithStatus: Dictionary<Integration[]>;
  brandWarnings: BrandWarning[];
  tableConfig: TableConfig<BrandWarning>;
  hasNext: boolean;
  hasPrev: boolean;
  handlePagination: (action: 'prev' | 'next') => void;
  loading: boolean;
};

const BrandWarningsView = ({
  brandWarnings,
  tableConfig,
  hasNext,
  hasPrev,
  handlePagination,
  loading,
  brand,
  adAccountId,
  integrationsWithStatus
}: BrandWarningsModalViewProps) => (
  <SectionLayout
    title="Warning log"
    titleAppendText={
      <BrandOverviewHeader
        brand={brand}
        metaAdAccountId={adAccountId}
        integrations={integrationsWithStatus}
      />
    }
  >
    <Text variant="h4"> All warnings </Text>
    <Table variant="normal" data={brandWarnings} config={tableConfig} />
    <ButtonGroup>
      {!!hasPrev && <Button label="Previous" onClick={() => handlePagination('prev')} />}
      {!!hasNext && <Button label="Next" onClick={() => handlePagination('next')} />}
    </ButtonGroup>
    {!!loading && <LoadingSpinner size={100} />}
  </SectionLayout>
);

export default BrandWarningsView;
